import React from 'react';

export const Einfamilienhaus: React.FC = () => (
  <>
    <g data-testid="Einfamilienhaus" clipPath="url(#clip0_4148_203342)">
      <rect width="636" height="493" fill="white" />
      <line
        x1="557.404"
        y1="301.832"
        x2="569.831"
        y2="311.596"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <line
        x1="1"
        y1="-1"
        x2="16.8045"
        y2="-1"
        transform="matrix(-0.786318 0.617822 0.617822 0.786318 592 302)"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <line
        x1="557.404"
        y1="328.832"
        x2="569.831"
        y2="338.596"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <line
        x1="1"
        y1="-1"
        x2="16.8045"
        y2="-1"
        transform="matrix(-0.786318 0.617822 0.617822 0.786318 592 329)"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M577.996 459H570V274.038C570 271.808 571.791 270 574 270C576.209 270 578 271.808 578 274.038V459H577.996Z"
        fill="white"
        stroke="black"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M547 290C546.448 290 546 290.448 546 291V293H548V291C548 290.448 547.552 290 547 290Z"
        fill="black"
      />
      <path
        d="M553 290C552.448 290 552 290.448 552 291V293H554V291C554 290.448 553.552 290 553 290Z"
        fill="black"
      />
      <path
        d="M595 290C594.448 290 594 290.448 594 291V293H596V291C596 290.448 595.552 290 595 290Z"
        fill="black"
      />
      <path
        d="M601 290C600.448 290 600 290.448 600 291V293H602V291C602 290.448 601.552 290 601 290Z"
        fill="black"
      />
      <path
        d="M605.991 302H542.009C541.449 302 541 301.495 541 300.874V295.126C541 294.501 541.453 294 542.009 294H605.991C606.551 294 607 294.505 607 295.126V300.874C607.004 301.495 606.551 302 605.991 302Z"
        fill="white"
        stroke="black"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M547 317C546.448 317 546 317.448 546 318V320H548V318C548 317.448 547.552 317 547 317Z"
        fill="black"
      />
      <path
        d="M553 317C552.448 317 552 317.448 552 318V320H554V318C554 317.448 553.552 317 553 317Z"
        fill="black"
      />
      <path
        d="M595 317C594.448 317 594 317.448 594 318V320H596V318C596 317.448 595.552 317 595 317Z"
        fill="black"
      />
      <path
        d="M601 317C600.448 317 600 317.448 600 318V320H602V318C602 317.448 601.552 317 601 317Z"
        fill="black"
      />
      <path
        d="M605.991 329H542.009C541.449 329 541 328.495 541 327.874V322.126C541 321.501 541.453 321 542.009 321H605.991C606.551 321 607 321.505 607 322.126V327.874C607.004 328.495 606.551 329 605.991 329Z"
        fill="white"
        stroke="black"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M607.5 324.751C631.007 332.616 656.166 336.877 682.32 336.877C708.793 336.877 734.247 332.511 758 324.461"
        stroke="black"
        strokeWidth="1.72"
      />
      <path
        d="M607.5 298.094C631.007 305.96 656.166 310.221 682.32 310.221C708.793 310.221 734.247 305.855 758 297.805"
        stroke="black"
        strokeWidth="1.72"
      />
      <path
        d="M543.748 426.72V457.597C543.748 458.019 544.077 458.364 544.481 458.364H551.177C551.581 458.364 551.91 458.019 551.91 457.597V426.72C551.91 426.4 551.798 426.087 551.596 425.84L548.242 421.785C548.022 421.519 547.629 421.519 547.408 421.785L544.055 425.84C543.86 426.087 543.748 426.396 543.748 426.72Z"
        fill="white"
      />
      <path
        d="M541 426.305V458.208C541 458.644 541.322 459 541.718 459H548.282C548.678 459 549 458.644 549 458.208V426.305C549 425.974 548.89 425.651 548.692 425.396L545.405 421.206C545.189 420.931 544.804 420.931 544.588 421.206L541.3 425.396C541.11 425.651 541 425.97 541 426.305Z"
        stroke="black"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M510.598 426.72V457.597C510.598 458.019 510.927 458.364 511.33 458.364H518.027C518.43 458.364 518.76 458.019 518.76 457.597V426.72C518.76 426.4 518.647 426.087 518.445 425.84L515.092 421.785C514.871 421.519 514.479 421.519 514.258 421.785L510.904 425.84C510.706 426.087 510.598 426.396 510.598 426.72Z"
        fill="white"
      />
      <path
        d="M510 426.305V458.208C510 458.644 510.323 459 510.718 459H517.282C517.677 459 518 458.644 518 458.208V426.305C518 425.974 517.89 425.651 517.692 425.396L514.405 421.206C514.189 420.931 513.804 420.931 513.588 421.206L510.301 425.396C510.106 425.651 510 425.97 510 426.305Z"
        stroke="black"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path d="M555.301 445.57H466.721V451.475H555.301V445.57Z" fill="white" />
      <path
        d="M555 445H467V451H555V445Z"
        stroke="black"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path d="M555.301 430.922H466.721V437.744H555.301V430.922Z" fill="white" />
      <path
        d="M555 431H467V437H555V431Z"
        stroke="black"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M545 433C544.446 433 544 433.446 544 434C544 434.554 544.446 435 545 435C545.554 435 546 434.554 546 434C546 433.452 545.554 433 545 433Z"
        fill="black"
      />
      <path
        d="M545 447C544.446 447 544 447.446 544 448C544 448.554 544.446 449 545 449C545.554 449 546 448.554 546 448C546 447.452 545.554 447 545 447Z"
        fill="black"
      />
      <path
        d="M514 433C513.446 433 513 433.446 513 434C513 434.554 513.446 435 514 435C514.554 435 515 434.554 515 434C515 433.452 514.554 433 514 433Z"
        fill="black"
      />
      <path
        d="M514 447C513.446 447 513 447.446 513 448C513 448.554 513.446 449 514 449C514.554 449 515 448.554 515 448C515 447.452 514.554 447 514 447Z"
        fill="black"
      />
      <path
        d="M492 273H20V459H492V273Z"
        fill="#F5F5F5"
        stroke="black"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M511.918 283H0.917969L56.1465 138H456.689L511.918 283Z"
        fill="#FFCC00"
        stroke="black"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <g clipPath="url(#clip1_4148_203342)">
        <path
          d="M511.918 283H0.917969L56.1465 138H456.689L511.918 283Z"
          fill="white"
          stroke="black"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
      </g>
      <mask id="path-33-inside-1_4148_203342" fill="white">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M394.206 260H478L453.714 192L379.962 192L394.206 260ZM379.124 188L452.286 188L428 120H364.881L379.124 188ZM360.794 120L375.038 188L299.357 188L294.303 120H360.794ZM375.876 192L390.119 260H304.708L299.654 192L375.876 192ZM295.346 188L290.292 120H223.734L219.14 188L295.346 188ZM300.697 260L295.643 192L218.869 192L214.275 260H300.697ZM219.725 120L215.131 188L139.962 188L154.206 120H219.725ZM214.86 192L210.266 260H124.881L139.124 192L214.86 192ZM135.876 188L150.119 120H84L59.7143 188L135.876 188ZM120.794 260L135.038 192L58.2857 192L34 260H120.794Z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M394.206 260H478L453.714 192L379.962 192L394.206 260ZM379.124 188L452.286 188L428 120H364.881L379.124 188ZM360.794 120L375.038 188L299.357 188L294.303 120H360.794ZM375.876 192L390.119 260H304.708L299.654 192L375.876 192ZM295.346 188L290.292 120H223.734L219.14 188L295.346 188ZM300.697 260L295.643 192L218.869 192L214.275 260H300.697ZM219.725 120L215.131 188L139.962 188L154.206 120H219.725ZM214.86 192L210.266 260H124.881L139.124 192L214.86 192ZM135.876 188L150.119 120H84L59.7143 188L135.876 188ZM120.794 260L135.038 192L58.2857 192L34 260H120.794Z"
        fill="#F5F5F5"
      />
      <path
        d="M394.206 260L392.248 260.41C392.442 261.336 393.259 262 394.206 262V260ZM478 260V262C478.65 262 479.26 261.684 479.635 261.152C480.009 260.62 480.102 259.94 479.883 259.327L478 260ZM453.714 192L455.598 191.327C455.314 190.531 454.56 190 453.714 190V192ZM379.962 192V190C379.36 190 378.79 190.272 378.41 190.739C378.03 191.207 377.881 191.821 378.005 192.41L379.962 192ZM379.124 188L377.167 188.41C377.361 189.337 378.178 190 379.124 190V188ZM452.286 188V190C452.936 190 453.546 189.684 453.921 189.152C454.295 188.621 454.388 187.94 454.169 187.327L452.286 188ZM428 120L429.883 119.327C429.599 118.531 428.845 118 428 118V120ZM364.881 120V118C364.279 118 363.709 118.271 363.329 118.739C362.949 119.207 362.8 119.82 362.924 120.41L364.881 120ZM375.038 188V190C375.64 190 376.21 189.729 376.59 189.261C376.97 188.793 377.119 188.18 376.995 187.59L375.038 188ZM360.794 120L362.752 119.59C362.558 118.664 361.741 118 360.794 118V120ZM299.357 188L297.362 188.148C297.44 189.192 298.31 190 299.357 190V188ZM294.303 120V118C293.747 118 293.216 118.232 292.837 118.639C292.459 119.047 292.267 119.594 292.308 120.148L294.303 120ZM390.119 260V262C390.721 262 391.291 261.729 391.671 261.261C392.051 260.793 392.2 260.18 392.076 259.59L390.119 260ZM375.876 192L377.833 191.59C377.639 190.664 376.822 190 375.876 190V192ZM304.708 260L302.714 260.148C302.791 261.192 303.661 262 304.708 262V260ZM299.654 192V190C299.098 190 298.567 190.232 298.188 190.639C297.81 191.047 297.618 191.594 297.66 192.148L299.654 192ZM290.292 120L292.286 119.852C292.209 118.808 291.339 118 290.292 118V120ZM295.346 188V190C295.902 190 296.433 189.768 296.812 189.361C297.19 188.953 297.382 188.406 297.34 187.852L295.346 188ZM223.734 120V118C222.682 118 221.81 118.815 221.739 119.865L223.734 120ZM219.14 188L217.144 187.865C217.107 188.418 217.3 188.961 217.679 189.366C218.057 189.77 218.586 190 219.14 190V188ZM295.643 192L297.638 191.852C297.56 190.808 296.69 190 295.643 190V192ZM300.697 260V262C301.253 262 301.784 261.768 302.163 261.361C302.541 260.953 302.733 260.406 302.692 259.852L300.697 260ZM218.869 192V190C217.817 190 216.945 190.815 216.874 191.865L218.869 192ZM214.275 260L212.279 259.865C212.242 260.418 212.436 260.961 212.814 261.366C213.192 261.77 213.721 262 214.275 262V260ZM215.131 188V190C216.183 190 217.055 189.185 217.126 188.135L215.131 188ZM219.725 120L221.721 120.135C221.758 119.582 221.564 119.039 221.186 118.634C220.808 118.23 220.279 118 219.725 118V120ZM139.962 188L138.005 187.59C137.881 188.18 138.03 188.793 138.41 189.261C138.79 189.729 139.36 190 139.962 190V188ZM154.206 120V118C153.259 118 152.442 118.664 152.248 119.59L154.206 120ZM210.266 260V262C211.318 262 212.19 261.185 212.261 260.135L210.266 260ZM214.86 192L216.856 192.135C216.893 191.582 216.7 191.039 216.321 190.634C215.943 190.23 215.414 190 214.86 190V192ZM124.881 260L122.924 259.59C122.8 260.18 122.949 260.793 123.329 261.261C123.709 261.729 124.279 262 124.881 262V260ZM139.124 192V190C138.178 190 137.361 190.664 137.167 191.59L139.124 192ZM150.119 120L152.076 120.41C152.2 119.82 152.051 119.207 151.671 118.739C151.291 118.271 150.721 118 150.119 118V120ZM135.876 188V190C136.822 190 137.639 189.336 137.833 188.41L135.876 188ZM84 120V118C83.1548 118 82.4008 118.531 82.1165 119.327L84 120ZM59.7143 188L57.8308 187.327C57.612 187.94 57.7048 188.62 58.0795 189.152C58.4541 189.684 59.0639 190 59.7143 190V188ZM135.038 192L136.995 192.41C137.119 191.82 136.97 191.207 136.59 190.739C136.21 190.272 135.64 190 135.038 190V192ZM120.794 260V262C121.741 262 122.558 261.336 122.752 260.41L120.794 260ZM58.2857 192V190C57.4405 190 56.6865 190.531 56.4022 191.327L58.2857 192ZM34 260L32.1165 259.327C31.8978 259.94 31.9905 260.62 32.3652 261.152C32.7398 261.684 33.3496 262 34 262V260ZM394.206 262H478V258H394.206V262ZM479.883 259.327L455.598 191.327L451.831 192.673L476.117 260.673L479.883 259.327ZM453.714 190L379.962 190V194L453.714 194V190ZM378.005 192.41L392.248 260.41L396.163 259.59L381.92 191.59L378.005 192.41ZM379.124 190L452.286 190V186L379.124 186V190ZM454.169 187.327L429.883 119.327L426.117 120.673L450.402 188.673L454.169 187.327ZM428 118H364.881V122H428V118ZM362.924 120.41L377.167 188.41L381.082 187.59L366.839 119.59L362.924 120.41ZM376.995 187.59L362.752 119.59L358.837 120.41L373.08 188.41L376.995 187.59ZM299.357 190L375.038 190V186L299.357 186V190ZM292.308 120.148L297.362 188.148L301.351 187.852L296.297 119.852L292.308 120.148ZM360.794 118H294.303V122H360.794V118ZM392.076 259.59L377.833 191.59L373.918 192.41L388.161 260.41L392.076 259.59ZM304.708 262H390.119V258H304.708V262ZM297.66 192.148L302.714 260.148L306.703 259.852L301.649 191.852L297.66 192.148ZM375.876 190L299.654 190V194L375.876 194V190ZM288.297 120.148L293.351 188.148L297.34 187.852L292.286 119.852L288.297 120.148ZM223.734 122H290.292V118H223.734V122ZM221.135 188.135L225.73 120.135L221.739 119.865L217.144 187.865L221.135 188.135ZM295.346 186L219.14 186V190L295.346 190V186ZM293.649 192.148L298.703 260.148L302.692 259.852L297.638 191.852L293.649 192.148ZM218.869 194L295.643 194V190L218.869 190V194ZM216.27 260.135L220.865 192.135L216.874 191.865L212.279 259.865L216.27 260.135ZM300.697 258H214.275V262H300.697V258ZM217.126 188.135L221.721 120.135L217.73 119.865L213.135 187.865L217.126 188.135ZM139.962 190L215.131 190V186L139.962 186V190ZM152.248 119.59L138.005 187.59L141.92 188.41L156.163 120.41L152.248 119.59ZM219.725 118H154.206V122H219.725V118ZM212.261 260.135L216.856 192.135L212.865 191.865L208.27 259.865L212.261 260.135ZM124.881 262H210.266V258H124.881V262ZM137.167 191.59L122.924 259.59L126.839 260.41L141.082 192.41L137.167 191.59ZM214.86 190L139.124 190V194L214.86 194V190ZM148.161 119.59L133.918 187.59L137.833 188.41L152.076 120.41L148.161 119.59ZM84 122H150.119V118H84V122ZM61.5978 188.673L85.8835 120.673L82.1165 119.327L57.8308 187.327L61.5978 188.673ZM135.876 186L59.7143 186V190L135.876 190V186ZM133.08 191.59L118.837 259.59L122.752 260.41L136.995 192.41L133.08 191.59ZM58.2857 194L135.038 194V190L58.2857 190V194ZM35.8835 260.673L60.1692 192.673L56.4022 191.327L32.1165 259.327L35.8835 260.673ZM120.794 258H34V262H120.794V258Z"
        fill="black"
        mask="url(#path-33-inside-1_4148_203342)"
      />
      <rect
        x="1"
        y="283"
        width="511"
        height="4"
        fill="#D9D9D9"
        stroke="black"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect width="73" height="131" transform="translate(76 328)" fill="#DDDDDD" />
      <rect
        x="76"
        y="328"
        width="73"
        height="131"
        stroke="black"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M139 372L139 416"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect x="104" y="337" width="16" height="113" fill="white" stroke="black" strokeWidth="2" />
      <rect width="113" height="67" transform="translate(325 328)" fill="white" />
      <g clipPath="url(#clip2_4148_203342)">
        <rect
          x="325"
          y="333"
          width="113"
          height="5"
          fill="#DDDDDD"
          stroke="black"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <rect
          x="325"
          y="333"
          width="113"
          height="5"
          fill="#DDDDDD"
          stroke="black"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <rect
          x="325"
          y="328"
          width="113"
          height="5"
          fill="#DDDDDD"
          stroke="black"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <rect
          x="325"
          y="328"
          width="113"
          height="5"
          fill="#DDDDDD"
          stroke="black"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <rect
          x="325"
          y="328"
          width="113"
          height="5"
          fill="#DDDDDD"
          stroke="black"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <rect
          x="325"
          y="328"
          width="113"
          height="5"
          fill="#DDDDDD"
          stroke="black"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <rect
          x="325"
          y="328"
          width="113"
          height="5"
          fill="#DDDDDD"
          stroke="black"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <rect
          x="325"
          y="333"
          width="113"
          height="5"
          fill="#DDDDDD"
          stroke="black"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <rect
          x="325"
          y="328"
          width="113"
          height="5"
          fill="#DDDDDD"
          stroke="black"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <rect
          x="325"
          y="328"
          width="113"
          height="5"
          fill="#DDDDDD"
          stroke="black"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <rect
          x="325"
          y="328"
          width="113"
          height="5"
          fill="#DDDDDD"
          stroke="black"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <rect
          x="325"
          y="328"
          width="113"
          height="5"
          fill="#DDDDDD"
          stroke="black"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <rect
          x="325"
          y="328"
          width="113"
          height="5"
          fill="#DDDDDD"
          stroke="black"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <rect
          x="379"
          y="338"
          width="6"
          height="3"
          fill="black"
          stroke="black"
          strokeLinejoin="round"
        />
      </g>
      <rect
        x="325"
        y="328"
        width="113"
        height="67"
        stroke="black"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path d="M362 338V395" stroke="black" strokeWidth="2" />
      <path d="M401 338V395" stroke="black" strokeWidth="2" />
      <path d="M438 364H325" stroke="black" strokeWidth="2" />
      <rect
        x="320"
        y="395"
        width="123"
        height="4"
        fill="#D9D9D9"
        stroke="black"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect width="73" height="67" transform="translate(200 328)" fill="white" />
      <g clipPath="url(#clip3_4148_203342)">
        <rect
          x="200"
          y="328"
          width="73"
          height="5"
          fill="#DDDDDD"
          stroke="black"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <rect
          x="200"
          y="328"
          width="73"
          height="5"
          fill="#DDDDDD"
          stroke="black"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <rect
          x="200"
          y="328"
          width="73"
          height="5"
          fill="#DDDDDD"
          stroke="black"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <rect
          x="200"
          y="328"
          width="73"
          height="5"
          fill="#DDDDDD"
          stroke="black"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <rect
          x="200"
          y="328"
          width="73"
          height="5"
          fill="#DDDDDD"
          stroke="black"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <rect
          x="200"
          y="328"
          width="73"
          height="5"
          fill="#DDDDDD"
          stroke="black"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <rect
          x="200"
          y="328"
          width="73"
          height="5"
          fill="#DDDDDD"
          stroke="black"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <rect
          x="200"
          y="328"
          width="73"
          height="5"
          fill="#DDDDDD"
          stroke="black"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <rect
          x="200"
          y="328"
          width="73"
          height="5"
          fill="#DDDDDD"
          stroke="black"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <rect
          x="200"
          y="328"
          width="73"
          height="5"
          fill="#DDDDDD"
          stroke="black"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <rect
          x="200"
          y="328"
          width="73"
          height="5"
          fill="#DDDDDD"
          stroke="black"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <rect
          x="200"
          y="328"
          width="73"
          height="5"
          fill="#DDDDDD"
          stroke="black"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <rect
          x="200"
          y="328"
          width="73"
          height="5"
          fill="#DDDDDD"
          stroke="black"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <rect
          x="234"
          y="333"
          width="6"
          height="3"
          fill="black"
          stroke="black"
          strokeLinejoin="round"
        />
        <path d="M237 333V395" stroke="black" strokeWidth="2" />
        <path d="M273 364H200" stroke="black" strokeWidth="2" />
      </g>
      <rect
        x="200"
        y="328"
        width="73"
        height="67"
        stroke="black"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect
        x="196"
        y="395"
        width="81"
        height="4"
        fill="#D9D9D9"
        stroke="black"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M541.356 27.8182L552.33 16.8438"
        stroke="#000207"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M477.453 91.7188L466.479 102.693"
        stroke="#000207"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M477.402 28.416L466.416 17.4297"
        stroke="#000207"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M541.402 92.4141L552.389 103.4"
        stroke="#000207"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M509.41 15.6037L509.395 -0.296875"
        stroke="#000207"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M509.477 105.297L509.488 121.202"
        stroke="#000207"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M464.599 60.4192L448.694 60.4075"
        stroke="#000207"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M554.288 60.4814L570.189 60.4973"
        stroke="#000207"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M485.841 84.618C499.05 97.8269 520.45 97.8426 533.639 84.653C546.829 71.4634 546.813 50.0632 533.604 36.8543C520.395 23.6454 498.995 23.6298 485.806 36.8193C472.616 50.0089 472.632 71.4091 485.841 84.618Z"
        fill="#FFCC00"
        stroke="#000207"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M670.168 110.27C669.59 110.241 669.011 110.241 668.433 110.27C666.062 103.222 661.401 97.0743 655.124 92.7124C648.847 88.3504 641.278 86 633.508 86C625.737 86 618.168 88.3504 611.891 92.7124C605.614 97.0743 600.953 103.222 598.582 110.27C598.004 110.27 597.425 110.27 596.847 110.27C593.717 110.268 590.618 110.853 587.726 111.992C584.834 113.131 582.205 114.801 579.991 116.908C577.777 119.014 576.019 121.515 574.82 124.269C573.62 127.022 573.002 129.973 573 132.954C572.995 139.01 575.495 144.824 579.959 149.137C584.422 153.451 590.489 155.916 596.847 156H670.168C676.527 155.924 682.597 153.46 687.06 149.145C691.522 144.829 694.016 139.011 694 132.954C693.996 126.936 691.483 121.167 687.014 116.913C682.546 112.659 676.486 110.27 670.168 110.27Z"
        fill="white"
        stroke="#000207"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </g>
    <defs>
      <clipPath id="clip0_4148_203342">
        <rect width="636" height="493" fill="white" />
      </clipPath>
      <clipPath id="clip1_4148_203342">
        <rect width="1" height="147" fill="white" transform="translate(1 137)" />
      </clipPath>
      <clipPath id="clip2_4148_203342">
        <rect width="113" height="67" fill="white" transform="translate(325 328)" />
      </clipPath>
      <clipPath id="clip3_4148_203342">
        <rect width="73" height="67" fill="white" transform="translate(200 328)" />
      </clipPath>
    </defs>
  </>
);
